<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M6,3C6,3,4,3,4,3C3.45,3,3,3.45,3,4C3,4,3,12,3,12C3,12.55,3.45,13,4,13C4,13,6,13,6,13C6.55,13,7,12.55,7,12C7,12,7,4,7,4C7,3.45,6.55,3,6,3C6,3,6,3,6,3ZM12,3C12,3,10,3,10,3C9.45,3,9,3.45,9,4C9,4,9,12,9,12C9,12.55,9.45,13,10,13C10,13,12,13,12,13C12.55,13,13,12.55,13,12C13,12,13,4,13,4C13,3.45,12.55,3,12,3C12,3,12,3,12,3Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Pause',
} as DefineComponent
</script>
